module.exports = __webpack_public_path__ + "static/media/qr_code.01812a1a.webp";